import { HistoryIcon } from "@graphiql/react";
/* empty css          */
import { History } from "./components.js";
import { HistoryStore, useHistory, useHistoryActions } from "./context.js";
import { useHistoryContext } from "./deprecated.js";
const HISTORY_PLUGIN = {
  title: "History",
  icon: HistoryIcon,
  content: History
};
export {
  HISTORY_PLUGIN,
  History,
  HistoryStore,
  useHistory,
  useHistoryActions,
  useHistoryContext
};
//# sourceMappingURL=index.js.map
